module.exports = __webpack_public_path__ + "static/media/card-tiendificar.78bbe13f.png";